import { render, staticRenderFns } from "./MtrbAdd.vue?vue&type=template&id=294e4a50&scoped=true&"
import script from "./MtrbAdd.vue?vue&type=script&lang=js&"
export * from "./MtrbAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294e4a50",
  null
  
)

export default component.exports